import { QUARTER_TURN_DEGREES, QUARTER_TURNS_PER_FULL_TURN } from "./documentRotation";
const HALF_TURN_QUARTERS = 2;
const THREE_QUARTER_TURN_QUARTERS = 3;

const PRECISION = 1e9;
const clean = (value: number) => Math.round(value * PRECISION) / PRECISION;

/** Rechnet eine Markierung (Anteile der Seite, links oben) auf die um `rotation` im Uhrzeigersinn gedrehte Seite um. */
export function rotateDocumentAnnotation<T extends { x: number; y: number; width: number; height: number }>(annotation: T, rotation: number): T {
  const turns = ((Math.round(rotation / QUARTER_TURN_DEGREES) % QUARTER_TURNS_PER_FULL_TURN) + QUARTER_TURNS_PER_FULL_TURN) % QUARTER_TURNS_PER_FULL_TURN;
  const { x, y, width, height } = annotation;
  // Gerundet, damit die Randprüfung der Markierungsschicht (Summe höchstens 1) nicht an Fließkommafehlern scheitert.
  if (turns === 1) return { ...annotation, x: clean(1 - y - height), y: clean(x), width: height, height: width };
  if (turns === HALF_TURN_QUARTERS) return { ...annotation, x: clean(1 - x - width), y: clean(1 - y - height) };
  if (turns === THREE_QUARTER_TURN_QUARTERS) return { ...annotation, x: clean(y), y: clean(1 - x - width), width: height, height: width };
  return annotation;
}
